import { Outlet, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import QueryWrapper from "common/components/QueryWrapper";
import { PlayLayout } from "common/layouts/PlayLayout";

import {
  DEFAULT_PSG_BACKGROUND_MOBILE,
  DEFAULT_WHITE_COLOR,
} from "../../_graphic_design";
import { useGetPronosticV2Query } from "pronosticsv2/api/pronosticv2.api";
import { useGetEventQuery } from "event/api/event.api";

export function PronosticsV2ThemeWrapper() {
  const { pronosticsV2Id } = useParams();
  const { eventId } = useParams();
  const event = useGetEventQuery(eventId || skipToken);

  const getPronosticV2Query = useGetPronosticV2Query(
    pronosticsV2Id || skipToken,
  );

  return (
    <QueryWrapper query={getPronosticV2Query}>
      {(pronosticV2) => {
        const gameTheme = {
          colors: {
            background: event.data?.colors.eventBackgroundColor || "#131527",
            text:
              pronosticV2.commonSettings?.webApp?.moduleSettings
                ?.messageTitleColor || DEFAULT_WHITE_COLOR,
          },
          images: {
            playBackground:
              pronosticV2.commonSettings?.webApp?.medias?.backGroundImage ||
              DEFAULT_PSG_BACKGROUND_MOBILE,
          },
          position:
            pronosticV2.commonSettings.webApp.moduleSettings.backGroundPosition,
        };

        return (
          <PlayLayout theme={gameTheme}>
            <Outlet />
          </PlayLayout>
        );
      }}
    </QueryWrapper>
  );
}
